import "./cards.scss";

interface WhiteCardProps {
  children: React.ReactNode;
  className?: string;
  headerSlot?: React.ReactNode;
  footerSlot?: React.ReactNode;
  styles?: React.CSSProperties;
  loading?: boolean;
}

export function WhiteCard({
  children,
  className,
  headerSlot,
  footerSlot,
  loading,
  styles = {},
}: WhiteCardProps) {
  return (
    <div
      className={`bg-white p-4 px-6 rounded-lg  w-full white-card ${className}`}
      style={{ ...styles }}
    >
      {headerSlot && <div className="white-card-header py-2">{headerSlot}</div>}
      {loading && <div>Chargement...</div>}
      {!loading && children}
      {footerSlot && <div className="white-card-footer py-2">{footerSlot}</div>}
    </div>
  );
}
